import { Utils } from './base/utils';
import { Slider } from '@parship/psg-slider';

const nodes: NodeListOf<HTMLElement> = document.querySelectorAll('.psg-slider');
nodes.forEach((node: HTMLElement) => {
	new Slider({
		target: node,
		itemsPerView: 1,
		loop: node.dataset.loop === 'true',
		breakpoints:
			node.dataset.itemsDesktop !== '1'
				? {
						'768': {
							itemsPerView: parseInt(node.dataset.itemsDesktop, 10),
						},
					}
				: undefined,
	});
});

new Utils();
